import { createStyles, makeStyles } from '@material-ui/core';
import { colorVariables } from '../../../styles/colorVariables';

export const useStyles = makeStyles(() =>
  createStyles({
    arrow: {
      color: 'rgba(70, 82, 116, 1)',
      fontSize: 32,
    },
    tooltip: {
      width: 300,
      minHeight: 120,
      backgroundColor: 'rgba(70, 82, 116, 1)',
      boxShadow: '0 0 0 1px rgba(70, 82, 116, 1)',
      borderRadius: 10,
      padding: '20px 30px',
    },
    tooltipText: {
      fontSize: 14,
      color: colorVariables.white,
      paddingTop: 5,
      marginBottom: 20,
      lineHeight: '22px',
      fontWeight: 400,
    },
    closeTooltip: {
      width: 15,
      height: 15,
      position: 'absolute',
      top: 5,
      right: 5,
      '& svg': {
        color: colorVariables.white,
        fontSize: 16,
      },
    },
    rootTooltip: {
      backgroundColor: colorVariables.transparent,
      padding: 0,
    },
  }),
);
